import type { AppModule } from '@/app/app-module.types';
import { authPublicRoutes } from './presentation/routes';

/**
 * Módulo de autenticação. Contribui apenas rotas públicas (login, cadastro,
 * recuperação de senha) — não tem item de menu nem rota protegida.
 *
 * Mantém o container manual (`authContainer`) consumido por AuthGuard,
 * sidebar e hooks; por isso não expõe `register`.
 */
export const authModule: AppModule = {
  name: 'auth',
  publicRoutes: authPublicRoutes,
};
